document.addEventListener("DOMContentLoaded", function () {
  initializeShopifyFormatMoney();
  handleMcMainProductImagesCarousel();
  handleMcMainProductAddToCart();
  handleMcMainProductVariantSelector();
  handleMcMainProductZoom();
});
// Expose functions globally for manual initialization
window.handleMcMainProductImagesCarousel = handleMcMainProductImagesCarousel;
window.handleMcMainProductAddToCart = handleMcMainProductAddToCart;
window.handleMcMainProductVariantSelector = handleMcMainProductVariantSelector;
window.handleMcMainProductZoom = handleMcMainProductZoom;

function getMcMainProductSlideImageUrl(slide) {
  var img = slide.querySelector("img");
  if (img) {
    return (
      img.currentSrc ||
      img.src ||
      img.dataset.deferredSrc ||
      img.getAttribute("src") ||
      ""
    );
  }

  return slide.getAttribute("data-img-src") || "";
}
/**
 * Handles product image carousel with Swiper.js
 * Stores the main swiper instance on the element for external access.
 * @param {HTMLElement} container - The container to scope the query selectors to
 */
// function handleMcMainProductImagesCarousel(container = document) {
//   const mainSwiperElement = container.querySelector(
//     ".mc-main-product__image-slider--main",
//   );
//   const thumbnailSwiperElement = container.querySelector(
//     ".mc-main-product__image-slider--thumbs",
//   );
//   const nextButton = container.querySelector(".mc-main-product-slider__next");
//   const prevButton = container.querySelector(".mc-main-product-slider__prev");
//   if (!mainSwiperElement) {
//     console.warn("Main swiper element not found.");
//     return;
//   }
//   // Initialize thumbnail swiper if it exists
//   var thumbnailSwiper = null;
//   if (thumbnailSwiperElement) {
//     thumbnailSwiper = new Swiper(thumbnailSwiperElement, {
//       spaceBetween: 10,
//       slidesPerView: 3,
//       freeMode: true,
//       watchSlidesProgress: true,
//     });
//   }
//   // Build main swiper configuration
//   var mainSwiperConfig = {
//     spaceBetween: 10,
//   };
//   // Add navigation if buttons exist
//   if (nextButton && prevButton) {
//     mainSwiperConfig.navigation = { nextEl: nextButton, prevEl: prevButton };
//   }
//   // Add thumbs if thumbnail swiper was initialized
//   if (thumbnailSwiper) {
//     mainSwiperConfig.thumbs = { swiper: thumbnailSwiper };
//   }
//   var mainSwiper = new Swiper(mainSwiperElement, mainSwiperConfig);
//   // Store the swiper instance on the DOM element so variant selector can access it
//   mainSwiperElement._swiperInstance = mainSwiper;
// }
function handleMcMainProductImagesCarousel(container = document) {
  const mainSwiperElement = container.querySelector(
    ".mc-main-product__image-slider--main",
  );
  const thumbnailSwiperElement = container.querySelector(
    ".mc-main-product__image-slider--thumbs",
  );
  const nextButton = container.querySelector(".mc-main-product-slider__next");
  const prevButton = container.querySelector(".mc-main-product-slider__prev");
  if (!mainSwiperElement) {
    console.warn("Main swiper element not found.");
    return;
  }

  // ============================================================
  // Safari mobile crashes when 100+ <img> elements exist in a
  // horizontal scroller — it ignores loading="lazy" and tries to
  // load/decode ALL of them, exceeding the iOS WebContent memory
  // budget and triggering a jetsam kill.
  //
  // Fix: strip src from off-screen images before Swiper init,
  // then restore only nearby images on slideChange.
  // ============================================================
  var PRELOAD_DISTANCE = 3;

  function deferImages(swiperContainer, keepFirst) {
    var imgs = swiperContainer.querySelectorAll(".swiper-slide img");
    imgs.forEach(function (img, i) {
      if (i < keepFirst) return;
      if (img.src && !img.dataset.deferredSrc) {
        img.dataset.deferredSrc = img.src;
        img.removeAttribute("src");
        if (img.srcset) {
          img.dataset.deferredSrcset = img.srcset;
          img.removeAttribute("srcset");
        }
      }
    });
  }

  function loadNearbyImages(swiperContainer, activeIndex) {
    var slides = swiperContainer.querySelectorAll(".swiper-slide");
    slides.forEach(function (slide, i) {
      var img = slide.querySelector("img");
      if (!img) return;
      var distance = Math.abs(i - activeIndex);
      if (distance <= PRELOAD_DISTANCE) {
        if (img.dataset.deferredSrc && !img.src) {
          img.src = img.dataset.deferredSrc;
          if (img.dataset.deferredSrcset) {
            img.srcset = img.dataset.deferredSrcset;
          }
        }
      } else {
        if (img.src) {
          if (!img.dataset.deferredSrc) {
            img.dataset.deferredSrc = img.src;
            if (img.srcset) {
              img.dataset.deferredSrcset = img.srcset;
            }
          }
          img.removeAttribute("src");
          img.removeAttribute("srcset");
        }
      }
    });
  }

  // Defer images BEFORE Swiper initializes
  deferImages(mainSwiperElement, PRELOAD_DISTANCE);
  if (thumbnailSwiperElement) {
    deferImages(thumbnailSwiperElement, PRELOAD_DISTANCE);
  }

  // Initialize thumbnail swiper if it exists
  var thumbnailSwiper = null;
  if (thumbnailSwiperElement) {
    thumbnailSwiper = new Swiper(thumbnailSwiperElement, {
      spaceBetween: 10,
      slidesPerView: 3,
      freeMode: true,
      watchSlidesProgress: true,
    });
  }
  // Build main swiper configuration
  var mainSwiperConfig = {
    spaceBetween: 10,
    on: {
      slideChange: function () {
        var activeIdx = this.activeIndex;
        loadNearbyImages(mainSwiperElement, activeIdx);
        if (thumbnailSwiperElement) {
          loadNearbyImages(thumbnailSwiperElement, activeIdx);
        }
      },
    },
  };
  // Add navigation if buttons exist
  if (nextButton && prevButton) {
    mainSwiperConfig.navigation = { nextEl: nextButton, prevEl: prevButton };
  }
  // Add thumbs if thumbnail swiper was initialized
  if (thumbnailSwiper) {
    mainSwiperConfig.thumbs = { swiper: thumbnailSwiper };
  }
  var mainSwiper = new Swiper(mainSwiperElement, mainSwiperConfig);
  // Store the swiper instance on the DOM element so variant selector can access it
  mainSwiperElement._swiperInstance = mainSwiper;
  // Expose loader so updateImageSlider can preload before sliding
  mainSwiperElement._loadNearbyImages = function (targetIndex) {
    loadNearbyImages(mainSwiperElement, targetIndex);
    if (thumbnailSwiperElement) {
      loadNearbyImages(thumbnailSwiperElement, targetIndex);
    }
  };
}

/**
 * Manages add to cart functionality with loading states and cart drawer updates
 */
function handleMcMainProductAddToCart(container = document) {
  var elements = {
    plusBtn: container.querySelector(".mc-main-product__quantity-plus"),
    minusBtn: container.querySelector(".mc-main-product__quantity-minus"),
    quantityInput: container.querySelector(".mc-main-product__quantity-input"),
    form: container.querySelector('form[data-type="add-to-cart-form"]'),
    submitBtn: container.querySelector(".mc-main-product__add-to-cart"),
    cartDrawer: document.querySelector("cart-drawer"),
  };
  if (!Object.values(elements).every(Boolean)) {
    console.warn(
      "Required elements for add to cart functionality are missing.",
    );
    return;
  }
  // Quantity Controls
  elements.plusBtn.addEventListener("click", function () {
    updateQuantity(1);
  });
  elements.minusBtn.addEventListener("click", function () {
    updateQuantity(-1);
  });
  function updateQuantity(change) {
    var currentQuantity = parseInt(elements.quantityInput.value) || 1;
    var newQuantity = Math.max(1, currentQuantity + change);
    elements.quantityInput.value = newQuantity;
  }
  // Add to Cart with Loading States
  elements.form.addEventListener("submit", async function (e) {
    e.preventDefault();
    var originalText = elements.submitBtn.textContent;
    try {
      setLoadingState(true, "ADDING TO CART...");
      var response = await fetch("/cart/add.js", {
        method: "POST",
        body: new FormData(elements.form),
      });
      var data = await response.json();
      if (data && data.id) {
        await updateCartDrawer();
        setLoadingState(false, "ADDED TO CART!");
        setTimeout(function () {
          elements.submitBtn.textContent = originalText;
        }, 2000);
      } else {
        // Handle Shopify API errors (e.g. 422 Out of Stock)
        var errorMsg = data.description || "ERROR - TRY AGAIN";
        setLoadingState(false, errorMsg);
        setTimeout(function () {
          elements.submitBtn.textContent = originalText;
        }, 3000);
      }
    } catch (error) {
      console.error("Add to cart error:", error);
      setLoadingState(false, "ERROR - TRY AGAIN");
      setTimeout(function () {
        elements.submitBtn.textContent = originalText;
      }, 3000);
    }
  });
  function setLoadingState(isLoading, text) {
    elements.submitBtn.disabled = isLoading;
    elements.submitBtn.textContent = text;
    elements.submitBtn.classList.toggle("loading", isLoading);
  }
  async function updateCartDrawer() {
    try {
      var response = await fetch("/?section_id=cart-drawer");
      var html = await response.text();
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, "text/html");
      var newCartDrawer = doc.querySelector("cart-drawer");
      var cartDrawer = document.querySelector("cart-drawer"); // Fresh reference
      if (newCartDrawer && cartDrawer) {
        cartDrawer.innerHTML = newCartDrawer.innerHTML;
        cartDrawer.classList.remove("is-empty");
        cartDrawer.classList.add("active");
        if (typeof cartDrawer.open === "function") {
          cartDrawer.open();
        }
      }
    } catch (error) {
      console.error("Error updating cart drawer:", error);
    }
  }
}
/**
 * Handles variant selection using multiple option dropdowns.
 * Finds the matching variant by combining selected options,
 * updates the hidden variant ID input, URL, price, image slider, and add-to-cart button.
 *
 * IMPORTANT: This function manages its own variant switching independently of
 * Shopify's built-in VariantSelects/product-info.js system. Change events are
 * stopped from propagating to prevent Shopify's section re-rendering from
 * conflicting and causing infinite loops (especially on Safari mobile).
 */
function handleMcMainProductVariantSelector(container = document) {
  var optionSelects = [];
  var variantIdInput = null;
  var variantDataScript = null;
  var selectedVariantDataScript = null;
  var variantsWrapper = null;
  var isHighVariantProduct = false;

  function refreshVariantSelectorElements() {
    optionSelects = container.querySelectorAll(
      ".mc-main-product__option-select",
    );
    variantIdInput = container.querySelector(
      ".mc-main-product__variant-id-input",
    );
    variantDataScript = container.querySelector(
      ".mc-main-product__variant-data",
    );
    selectedVariantDataScript = container.querySelector(
      ".mc-main-product__selected-variant-data",
    );
    variantsWrapper = container.querySelector(".mc-main-product__variants");
    isHighVariantProduct =
      variantsWrapper &&
      variantsWrapper.getAttribute("data-high-variant") === "true";
  }

  refreshVariantSelectorElements();

  // Determine if this is a DFW product from the data attribute
  var productContainer = container.querySelector(".mc-main-product");

  // Prevent double initialization (Shopify section re-rendering can call this again)
  if (productContainer && productContainer._variantSelectorInitialized) return;
  if (productContainer) productContainer._variantSelectorInitialized = true;

  var isDfw = false;
  if (productContainer) {
    isDfw = productContainer.getAttribute("data-is-dfw") === "true";
  }

  // Local update guard (properly scoped, not implicit global)
  var isUpdating = false;
  var debounceTimer = null;

  // Overflow overlay globals
  var overflowOverlay = null;
  var overflowOverlayImg = null;
  var overflowConfig = container.querySelector("#overflow-overlay-config");

  function initOverflowOverlay() {
    if (!overflowConfig) return;
    var sliderContainer = container.querySelector(
      ".mc-main-product__image-slider--main",
    );
    if (!sliderContainer) return;
    if (!overflowOverlay) {
      if (window.getComputedStyle(sliderContainer).position === "static") {
        sliderContainer.style.position = "relative";
      }
      overflowOverlay = document.createElement("div");
      overflowOverlay.className = "overflow-overlay";
      overflowOverlay.id = "overflow-overlay";
      overflowOverlay.setAttribute("aria-hidden", "true");
      var badge = document.createElement("div");
      badge.id = "overflow-overlay-badge";
      badge.textContent = "Overflow";
      overflowOverlayImg = document.createElement("img");
      overflowOverlayImg.id = "overflow-overlay-img";
      overflowOverlayImg.alt = "";
      overflowOverlayImg.setAttribute("role", "presentation");
      overflowOverlay.appendChild(badge);
      overflowOverlay.appendChild(overflowOverlayImg);
      sliderContainer.appendChild(overflowOverlay);
    }
  }

  function updateOverflowOverlay() {
    if (!overflowOverlay || !overflowOverlayImg || !overflowConfig) return;
    var overflowValue = null;
    optionSelects.forEach(function (select) {
      var name = select.getAttribute("name") || "";
      var id = select.getAttribute("id") || "";
      if (
        id.toLowerCase().includes("overflow") ||
        name.toLowerCase().includes("overflow") ||
        id.toLowerCase().includes("flow") ||
        name.toLowerCase().includes("flow")
      ) {
        overflowValue = select.value.toLowerCase();
      }
    });
    if (!overflowValue) {
      overflowOverlay.classList.remove("is-visible");
      overflowOverlayImg.src = "";
      overflowOverlay.setAttribute("aria-hidden", "true");
      return;
    }
    var internalUrl = overflowConfig.getAttribute("data-internal-url");
    var externalUrl = overflowConfig.getAttribute("data-external-url");
    var badge = document.getElementById("overflow-overlay-badge");
    if (overflowValue.includes("internal")) {
      overflowOverlayImg.src = internalUrl;
      overflowOverlayImg.alt = "Internal overflow";
      if (badge) badge.textContent = "Internal";
      overflowOverlay.classList.add("is-visible");
      overflowOverlay.setAttribute("aria-hidden", "false");
    } else if (overflowValue.includes("external")) {
      overflowOverlayImg.src = externalUrl;
      overflowOverlayImg.alt = "External overflow";
      if (badge) badge.textContent = "External";
      overflowOverlay.classList.add("is-visible");
      overflowOverlay.setAttribute("aria-hidden", "false");
    } else {
      overflowOverlay.classList.remove("is-visible");
      overflowOverlayImg.src = "";
      overflowOverlay.setAttribute("aria-hidden", "true");
    }
  }

  initOverflowOverlay();

  // Handle products with multiple option selects
  if (optionSelects.length > 0 && variantDataScript) {
    var variants = [];
    try {
      variants = JSON.parse(variantDataScript.textContent);
    } catch (e) {
      console.error("Failed to parse variant data:", e);
      return;
    }

    wireOptionSelects(variants);

    // Single guarded init call — no URL update during init (changedSelect is null)
    isUpdating = true;
    if (isHighVariantProduct) {
      applyHighVariantState(null);
    } else {
      onOptionChange(variants, null);
    }
    isUpdating = false;
  } else if (!optionSelects.length) {
    // Handle products with single variant (no selector)
    handleSingleVariantProduct();
  }

  function wireOptionSelects(variants) {
    optionSelects.forEach(function (select) {
      if (select._mcVariantSelectorBound) return;
      select._mcVariantSelectorBound = true;
      select.addEventListener("change", function (event) {
        // CRITICAL: Stop propagation to prevent Shopify's built-in VariantSelects
        // (in global.js) from catching this event and triggering product-info.js
        // section re-rendering. Without this, Shopify replaces the entire product
        // section DOM on every change, destroying our Swiper/listeners and causing
        // an infinite loop that crashes Safari mobile.
        event.stopPropagation();

        // Ignore programmatic .value changes from filterAvailableOptions
        if (this._suppressChange) return;

        var self = this;
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(function () {
          if (!isUpdating) {
            isUpdating = true;
            if (isHighVariantProduct) {
              handleHighVariantOptionChange(self, variants)
                .catch(function (error) {
                  console.error("Failed to update high-variant selector:", error);
                })
                .finally(function () {
                  isUpdating = false;
                });
            } else {
              try {
                onOptionChange(variants, self);
              } finally {
                isUpdating = false;
              }
            }
          }
        }, 10);
      });
    });
  }

  function getSelectedOptionValueIds() {
    var selectedIds = [];
    optionSelects.forEach(function (select) {
      if (!select.closest(".mc-main-product__variants")) return;
      var option = select.options[select.selectedIndex];
      if (option && option.getAttribute("data-option-value-id")) {
        selectedIds.push(option.getAttribute("data-option-value-id"));
      }
    });
    return selectedIds;
  }

  function getSelectedVariantFromScript() {
    if (!selectedVariantDataScript) return null;
    try {
      var variant = JSON.parse(selectedVariantDataScript.textContent);
      if (!variant || !variant.id || !selectedValuesMatchVariant(variant)) {
        return null;
      }
      return normalizeVariantData(variant);
    } catch (e) {
      return null;
    }
  }

  function selectedValuesMatchVariant(variant) {
    if (!variant.options || !variant.options.length) return false;
    for (var i = 0; i < optionSelects.length; i++) {
      var select = optionSelects[i];
      if (!select.closest(".mc-main-product__variants")) continue;
      var index = parseInt(select.getAttribute("data-option-index"), 10);
      if (isNaN(index) || !variant.options[index]) return false;
      if (String(variant.options[index]).trim() !== select.value.trim()) {
        return false;
      }
    }
    return true;
  }

  function getSelectedVariantFromOptions() {
    var selectedOptions = [];
    optionSelects.forEach(function (select) {
      if (!select.closest(".mc-main-product__variants")) return;
      selectedOptions.push(select.options[select.selectedIndex]);
    });

    for (var i = selectedOptions.length - 1; i >= 0; i--) {
      var option = selectedOptions[i];
      if (option && option.getAttribute("data-variant-id")) {
        return normalizeVariantData({
          id: option.getAttribute("data-variant-id"),
          available: option.getAttribute("data-variant-available") === "true",
          price: option.getAttribute("data-variant-price"),
          compare_at_price: option.getAttribute(
            "data-variant-compare-at-price",
          ),
          options: Array.prototype.map.call(optionSelects, function (select) {
            return select.value;
          }),
          featured_media_id: option.getAttribute(
            "data-variant-featured-media-id",
          ),
          featured_image_src: option.getAttribute(
            "data-variant-featured-image-src",
          ),
        });
      }
    }

    return getSelectedVariantFromScript();
  }

  function normalizeVariantData(variant) {
    if (!variant) return null;
    var normalized = Object.assign({}, variant);
    normalized.id = parseInt(normalized.id, 10);
    normalized.price = parseInt(normalized.price, 10);
    if (isNaN(normalized.price)) normalized.price = 0;
    normalized.compare_at_price = parseInt(normalized.compare_at_price, 10);
    if (isNaN(normalized.compare_at_price)) normalized.compare_at_price = null;
    normalized.featured_media_id = parseInt(normalized.featured_media_id, 10);
    if (isNaN(normalized.featured_media_id)) {
      normalized.featured_media_id = null;
    }
    normalized.available =
      normalized.available === true || normalized.available === "true";
    normalized.featured_image_src = normalized.featured_image_src || "";
    return normalized.id ? normalized : null;
  }

  function applyHighVariantState(changedSelect) {
    var matchedVariant = getSelectedVariantFromOptions();
    if (matchedVariant) {
      if (variantIdInput) {
        variantIdInput.value = matchedVariant.id;
      }
      if (changedSelect !== null) {
        updateURL(matchedVariant.id);
      }
      updatePriceDisplays(matchedVariant);
      updateAddToCartButton(matchedVariant);
      updateImageSlider(matchedVariant);
      updateOverflowOverlay();
    } else {
      if (variantIdInput) {
        variantIdInput.value = "";
      }
      updateAddToCartButton(null);
      updateOverflowOverlay();
    }
  }

  async function handleHighVariantOptionChange(changedSelect, variants) {
    var selectedIds = getSelectedOptionValueIds();
    if (!selectedIds.length) {
      applyHighVariantState(changedSelect);
      return;
    }

    var sectionIdInput =
      container.querySelector('[name="section-id"]') ||
      document.querySelector('[name="section-id"]');
    var sectionId =
      (variantsWrapper ? variantsWrapper.getAttribute("data-section-id") : "") ||
      (sectionIdInput ? sectionIdInput.value : "");
    if (!sectionId || !variantsWrapper) {
      applyHighVariantState(changedSelect);
      return;
    }

    var changedIndex = changedSelect
      ? changedSelect.getAttribute("data-option-index")
      : null;
    var productUrl =
      variantsWrapper.getAttribute("data-product-url") ||
      window.location.pathname;
    var requestUrl = new URL(productUrl, window.location.origin);
    requestUrl.searchParams.set("section_id", sectionId);
    requestUrl.searchParams.set("option_values", selectedIds.join(","));

    try {
      updateAddToCartButton(null);
      var response = await fetch(requestUrl.toString(), {
        headers: { "X-Requested-With": "XMLHttpRequest" },
      });
      if (!response.ok) throw new Error("Section render failed");

      var html = await response.text();
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, "text/html");
      var newVariantsWrapper = doc.querySelector(".mc-main-product__variants");
      var currentVariantsWrapper = container.querySelector(
        ".mc-main-product__variants",
      );

      if (!newVariantsWrapper || !currentVariantsWrapper) {
        applyHighVariantState(changedSelect);
        return;
      }

      currentVariantsWrapper.innerHTML = newVariantsWrapper.innerHTML;
      Array.prototype.slice
        .call(currentVariantsWrapper.attributes)
        .forEach(function (attribute) {
          if (attribute.name !== "class") {
            currentVariantsWrapper.removeAttribute(attribute.name);
          }
        });
      Array.prototype.slice
        .call(newVariantsWrapper.attributes)
        .forEach(function (attribute) {
          currentVariantsWrapper.setAttribute(attribute.name, attribute.value);
        });

      refreshVariantSelectorElements();
      wireOptionSelects(variants);
      applyHighVariantState(changedSelect);

      if (changedIndex !== null) {
        var refreshedSelect = container.querySelector(
          '.mc-main-product__option-select[data-option-index="' +
            changedIndex +
            '"]',
        );
        if (refreshedSelect) refreshedSelect.focus();
      }
    } catch (error) {
      console.error("Failed to update high-variant selector:", error);
      applyHighVariantState(changedSelect);
    }
  }

  /**
   * Filters dropdown options so only valid combinations are selectable.
   * For each dropdown, checks if its options can form a valid variant
   * when combined with the other currently selected values.
   * If the currently selected value becomes invalid, auto-selects the first valid option.
   *
   * Uses _suppressChange flag to prevent Safari from firing synthetic change
   * events when .value is set programmatically.
   *
   * @param {Array} variants - The full list of product variants
   * @param {HTMLElement|null} changedSelect - The dropdown that was just changed (not filtered itself)
   */
  function filterAvailableOptions(variants, changedSelect) {
    if (isHighVariantProduct) return;

    // Get all main variant selects
    const mainSelects = [];
    optionSelects.forEach(function (select) {
      if (select.closest(".mc-main-product__variants")) {
        mainSelects.push(select);
      }
    });

    // For each dropdown, determine which of its option values are valid
    mainSelects.forEach(function (currentSelect) {
      const currentIndex = parseInt(
        currentSelect.getAttribute("data-option-index"),
      );
      if (isNaN(currentIndex)) return;

      // Build a map of selected values from OTHER dropdowns (not the current one)
      const otherSelectedMap = {};
      mainSelects.forEach(function (otherSelect) {
        const otherIndex = parseInt(
          otherSelect.getAttribute("data-option-index"),
        );
        if (!isNaN(otherIndex) && otherIndex !== currentIndex) {
          otherSelectedMap[otherIndex] = otherSelect.value.trim();
        }
      });

      // For each option in this dropdown, check if at least one variant exists
      // that matches ALL other selected options + this option value
      const options = currentSelect.querySelectorAll("option");
      let hasValidSelection = false;
      let firstValidValue = null;

      options.forEach(function (option) {
        const optionValue = option.value.trim();
        if (!optionValue) return; // Skip placeholder options

        // Check if any variant matches this option + all other selected options
        const isValid = variants.some(function (variant) {
          // This option's value must match
          if (
            variant.options[currentIndex] &&
            variant.options[currentIndex].trim() !== optionValue
          )
            return false;
          // All other selected options must match too
          for (var idx in otherSelectedMap) {
            if (
              variant.options[idx] &&
              variant.options[idx].trim() !== otherSelectedMap[idx]
            )
              return false;
          }
          return true;
        });

        if (isValid) {
          option.disabled = false;
          option.style.display = "";
          if (!firstValidValue) firstValidValue = optionValue;
          if (option.selected) hasValidSelection = true;
        } else {
          option.disabled = true;
          option.style.display = "none";
        }
      });

      // If current selection is now invalid, auto-select the first valid option.
      // _suppressChange prevents Safari from firing a synthetic change event
      // that would cascade through our handler and Shopify's VariantSelects.
      if (!hasValidSelection && firstValidValue) {
        currentSelect._suppressChange = true;
        currentSelect.value = firstValidValue;
        currentSelect._suppressChange = false;
      }
    });
  }

  /**
   * Called whenever any option dropdown changes.
   * Filters available options in other dropdowns, then
   * finds the matching variant and updates all UI.
   */
  function onOptionChange(variants, changedSelect) {
    // Smart filter: hide invalid options in other dropdowns
    filterAvailableOptions(variants, changedSelect);

    // Build selected options map using data-option-index
    const selectedOptionsMap = {};
    optionSelects.forEach(function (select) {
      if (select.closest(".mc-main-product__variants")) {
        // Ensure we only read from the main selector UI
        const index = parseInt(select.getAttribute("data-option-index"));
        if (!isNaN(index)) {
          selectedOptionsMap[index] = select.value.trim();
        }
      }
    });

    // Find matching variant
    const matchedVariant = variants.find(function (variant) {
      return variant.options.every(function (opt, index) {
        const selectedValue = selectedOptionsMap[index];
        if (typeof selectedValue === "undefined") return false;
        return opt.trim() === selectedValue;
      });
    });

    if (matchedVariant) {
      // Update hidden input
      if (variantIdInput) {
        variantIdInput.value = matchedVariant.id;
      }
      // Only update URL on user-initiated changes (not init)
      // This prevents Shopify section re-rendering on page load
      if (changedSelect !== null) {
        updateURL(matchedVariant.id);
      }
      updatePriceDisplays(matchedVariant);
      updateAddToCartButton(matchedVariant);
      updateImageSlider(matchedVariant);
      updateOverflowOverlay();
    } else {
      if (variantIdInput) {
        variantIdInput.value = "";
      }
      updateAddToCartButton(null);
    }
  }

  /**
   * Handles products with only one variant (no variant selector)
   */
  async function handleSingleVariantProduct() {
    try {
      var productHandle = window.location.pathname.split("/").pop();
      var response = await fetch("/products/" + productHandle + ".js");
      var productData = await response.json();
      // Get the first (and only) variant
      var defaultVariant = productData.variants[0];
      if (defaultVariant) {
        updateURL(defaultVariant.id);
        updatePriceDisplays(defaultVariant);
        updateAddToCartButton(defaultVariant);
        updateOverflowOverlay();
      }
    } catch (error) {
      console.error("Error updating single variant:", error);
    }
  }

  /**
   * Updates browser URL with selected variant ID.
   * Debounced and deduplicated to prevent hitting Safari's
   * 100 replaceState/pushState per 30 second limit.
   * @param {string} variantId - The selected variant ID
   */
  var lastVariantId = null;
  var urlTimer = null;

  function updateURL(variantId) {
    if (variantId === lastVariantId) return;
    lastVariantId = variantId;
    clearTimeout(urlTimer);
    urlTimer = setTimeout(function () {
      try {
        var url = new URL(window.location);
        url.searchParams.set("variant", variantId);
        window.history.replaceState({}, "", url);
      } catch (e) {
        console.warn("replaceState blocked:", e);
      }
    }, 100);
  }

  /**
   * Updates price displays based on selected variant
   * @param {Object} variant - The selected variant object
   */
  function updatePriceDisplays(variant) {
    var priceElement = container.querySelector(
      ".mc-main-product__price-current",
    );
    if (priceElement) {
      priceElement.textContent = formatMoneyWithoutTrailingZeros(variant.price);
    }
    var compareAtPriceElement = container.querySelector(
      ".mc-main-product__price-compare",
    );
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      if (compareAtPriceElement) {
        compareAtPriceElement.textContent = formatMoneyWithoutTrailingZeros(
          variant.compare_at_price,
        );
        compareAtPriceElement.style.display = "inline";
        compareAtPriceElement.classList.remove("hidden");
      }
    } else {
      if (compareAtPriceElement) {
        compareAtPriceElement.style.display = "none";
        compareAtPriceElement.classList.add("hidden");
      }
    }
    var priceElements = container.querySelectorAll("[data-product-price]");
    priceElements.forEach(function (element) {
      element.textContent = formatMoneyWithoutTrailingZeros(variant.price);
    });
  }

  /**
   * Updates add to cart button state based on variant availability.
   * @param {Object|null} variant - The selected variant object, or null if combination does not exist
   */
  function updateAddToCartButton(variant) {
    const addToCartBtn = container.querySelector(
      ".mc-main-product__add-to-cart",
    );
    if (!addToCartBtn) return;
    // Skip if this button belongs to the ghost product selector (managed by ghost-product-selector.js)
    if (addToCartBtn.closest(".ghost-product-selector")) return;
    if (!variant) {
      addToCartBtn.disabled = true;
      addToCartBtn.textContent = "UNAVAILABLE";
      return;
    }
    if (variant.price === 0) {
      addToCartBtn.disabled = false;
      addToCartBtn.textContent = "Customize For Price";
      return;
    }
    if (variant.available) {
      addToCartBtn.disabled = false;
      addToCartBtn.textContent =
        addToCartBtn.getAttribute("data-add-to-cart-text") || "ADD TO CART";
    } else {
      addToCartBtn.disabled = true;
      addToCartBtn.textContent =
        addToCartBtn.getAttribute("data-sold-out-text") || "SOLD OUT";
    }
  }

  /**
   * Loads color-to-image mapping data from the embedded JSON script.
   * Returns an object like { "Black": { media_id: 123, image_src: "..." }, ... }
   */
  function getColorImageMap() {
    var colorDataScript = container.querySelector(
      ".mc-main-product__color-image-data",
    );
    if (!colorDataScript) return null;
    try {
      return JSON.parse(colorDataScript.textContent);
    } catch (e) {
      return null;
    }
  }

  /**
   * Finds the Color option index from the option selects.
   * Returns the index or -1 if not found.
   */
  function getColorOptionIndex() {
    for (var i = 0; i < optionSelects.length; i++) {
      var name = optionSelects[i].getAttribute("name") || "";
      var id = optionSelects[i].getAttribute("id") || "";
      if (
        id.toLowerCase().includes("color") ||
        name.toLowerCase().includes("color")
      ) {
        return i;
      }
    }
    return -1;
  }

  /**
   * Slides the main image carousel to the variant's featured media.
   * Uses multiple matching strategies with color fallback:
   *   1. Match by featured_media_id (data-media-id attribute on slides)
   *   2. Fallback: match by featured_image_src (compare against slide image URLs)
   *   3. Color fallback: find same-color image from color-image map
   *   4. Show "no photo" message if no image found at all
   *
   * @param {Object} variant - The selected variant object (from JSON)
   */
  function updateImageSlider(variant) {
    var mainSwiperElement = container.querySelector(
      ".mc-main-product__image-slider--main",
    );
    if (!mainSwiperElement || !mainSwiperElement._swiperInstance) return;
    var swiperInstance = mainSwiperElement._swiperInstance;
    var slides = mainSwiperElement.querySelectorAll(".swiper-slide");
    var targetIndex = -1;
    var exactMatch = false;
    // UI elements for overlay/no-photo
    var noPhotoMsg = document.getElementById("mc-no-photo-message");
    var colorOverlay = document.getElementById("mc-color-overlay");
    // Strategy 1: Match by featured_media_id
    if (variant.featured_media_id) {
      for (var i = 0; i < slides.length; i++) {
        if (
          slides[i].getAttribute("data-media-id") ==
          variant.featured_media_id
        ) {
          targetIndex = i;
          exactMatch = true;
          break;
        }
      }
    }
    // Strategy 2: Fallback to matching by image src
    if (targetIndex === -1 && variant.featured_image_src) {
      var variantImageFile = extractImageFilename(variant.featured_image_src);
      if (variantImageFile) {
        for (var j = 0; j < slides.length; j++) {
          var slideImageUrl = getMcMainProductSlideImageUrl(slides[j]);
          if (slideImageUrl) {
            var slideImageFile = extractImageFilename(slideImageUrl);
            if (slideImageFile && slideImageFile === variantImageFile) {
              targetIndex = j;
              exactMatch = true;
              break;
            }
          }
        }
      }
    }
    // Strategy 3: Color fallback - find same color image from color-image map
    if (targetIndex === -1) {
      var colorIndex = getColorOptionIndex();
      if (colorIndex !== -1) {
        var selectedColor = optionSelects[colorIndex].value;
        var colorMap = getColorImageMap();
        if (colorMap && colorMap[selectedColor]) {
          var fallbackMediaId = colorMap[selectedColor].media_id;
          for (var k = 0; k < slides.length; k++) {
            if (slides[k].getAttribute("data-media-id") == fallbackMediaId) {
              targetIndex = k;
              exactMatch = false;
              break;
            }
          }
        }
      }
    }
    // Slide to the matched index if found
    // if (targetIndex !== -1) {
    //   swiperInstance.slideTo(targetIndex);
    if (targetIndex !== -1) {
      // Load images at target before sliding so the slide isn't blank
      if (mainSwiperElement._loadNearbyImages) {
        mainSwiperElement._loadNearbyImages(targetIndex);
      }
      swiperInstance.slideTo(targetIndex);
      if (exactMatch) {
        if (noPhotoMsg) noPhotoMsg.style.display = "none";
        if (colorOverlay) colorOverlay.style.display = "none";
      } else {
        if (noPhotoMsg) noPhotoMsg.style.display = "";
        if (colorOverlay) colorOverlay.style.display = "";
      }
    } else {
      // No image found at all - show no-photo message
      if (noPhotoMsg) noPhotoMsg.style.display = "";
      if (colorOverlay) colorOverlay.style.display = "none";
    }
  }

  /**
   * Extracts the core filename from a Shopify CDN image URL.
   * Strips size suffixes like _100x, _5000x5000 etc. for clean comparison.
   * Example: ".../my-image_100x.jpg" -> "my-image.jpg"
   * @param {string} url - Full image URL
   * @returns {string|null} The extracted filename, or null if extraction fails
   */
  function extractImageFilename(url) {
    if (!url) return null;
    try {
      // Get the pathname and then the filename
      var pathname = new URL(url, window.location.origin).pathname;
      var filename = pathname.split("/").pop();
      // Remove Shopify size suffixes like _100x, _5000x5000, _grande, etc.
      return filename.replace(
        /_((\d+x\d*|\d*x\d+|pico|icon|thumb|small|compact|medium|large|grande|original|master))(\.|$)/g,
        "$3",
      );
    } catch (e) {
      return null;
    }
  }

  /**
   * Formats money without trailing zeros (.00)
   * @param {number} cents - Price in cents
   * @returns {string} Formatted price string
   */
  function formatMoneyWithoutTrailingZeros(cents) {
    var formatted = Shopify.formatMoney(cents);
    return formatted.replace(".00", "");
  }

  // ============================================
  // Color Guide Modal Logic
  // ============================================
  function openColorModal() {
    var modal = document.getElementById("mc-color-modal");
    if (modal) {
      modal.style.display = "";
      document.body.style.overflow = "hidden";
    }
  }

  function closeColorModal() {
    var modal = document.getElementById("mc-color-modal");
    if (modal) {
      modal.style.display = "none";
      document.body.style.overflow = "";
    }
  }

  // Wire up overlay link clicks to open modal
  var overlayLink = document.getElementById("mc-color-overlay-link");
  if (overlayLink) {
    overlayLink.addEventListener("click", function (e) {
      e.preventDefault();
      openColorModal();
    });
  }
  var noPhotoLink = document.getElementById("mc-no-photo-link");
  if (noPhotoLink) {
    noPhotoLink.addEventListener("click", function (e) {
      e.preventDefault();
      openColorModal();
    });
  }
  // Wire up modal close handlers
  var modalClose = document.getElementById("mc-color-modal-close");
  if (modalClose) {
    modalClose.addEventListener("click", closeColorModal);
  }
  var modalBackdrop = document.getElementById("mc-color-modal-backdrop");
  if (modalBackdrop) {
    modalBackdrop.addEventListener("click", closeColorModal);
  }
  // Close on Escape key
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      closeColorModal();
    }
  });
}
/**
 * Initializes Shopify money formatting with store currency settings
 */
function initializeShopifyFormatMoney() {
  if (!window.Shopify) {
    window.Shopify = {};
  }
  Shopify.formatMoney = function (cents, format) {
    if (typeof cents == "string") {
      cents = cents.replace(".", "");
    }
    var value = "";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || this.money_format;
    function defaultOption(opt, def) {
      return typeof opt == "undefined" ? def : opt;
    }
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ",");
      decimal = defaultOption(decimal, ".");
      if (isNaN(number) || number == null) {
        return 0;
      }
      number = (number / 100.0).toFixed(precision);
      var parts = number.split("."),
        dollars = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          "$1" + thousands,
        ),
        cents = parts[1] ? decimal + parts[1] : "";
      return dollars + cents;
    }
    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
    }
    return formatString.replace(placeholderRegex, value);
  };
}

/**
 * Opens product images in an accessible gallery modal instead of using an inner magnifier.
 */
function handleMcMainProductZoom() {
  var zoomSlides = document.querySelectorAll(".swiper-slide.has-zoom");
  if (!zoomSlides.length) return;

  var modal = getOrCreateProductImageModal();

  zoomSlides.forEach(function (slide) {
    if (slide._mcImageModalBound) return;

    slide._mcImageModalBound = true;
    slide.removeAttribute("role");
    slide.removeAttribute("tabindex");
    slide.removeAttribute("aria-label");

    var openButton = getOrCreateProductImageModalOpenButton(slide);

    openButton.addEventListener("click", function (event) {
      event.stopPropagation();
      openProductImageModal(slide, modal);
    });

    slide.addEventListener("click", function (event) {
      if (
        event.target.closest &&
        event.target.closest("a, button, input, select, textarea, label")
      ) {
        return;
      }

      openProductImageModal(slide, modal);
    });
  });
}

function getOrCreateProductImageModalOpenButton(slide) {
  var existingButton = slide.querySelector(".mc-product-image-modal__open");
  if (existingButton) return existingButton;

  var button = document.createElement("button");
  button.type = "button";
  button.className = "mc-product-image-modal__open";
  button.setAttribute(
    "aria-label",
    getProductModalImageAlt(slide)
      ? "Open larger product image: " + getProductModalImageAlt(slide)
      : "Open larger product image",
  );
  button.innerHTML = [
    '<svg aria-hidden="true" focusable="false" viewBox="0 0 24 24">',
    '<path d="M8 3H3v5h2V6.4l4.3 4.3 1.4-1.4L6.4 5H8V3Z"/>',
    '<path d="M16 3v2h1.6l-4.3 4.3 1.4 1.4L19 6.4V8h2V3h-5Z"/>',
    '<path d="M6.4 19l4.3-4.3-1.4-1.4L5 17.6V16H3v5h5v-2H6.4Z"/>',
    '<path d="M17.6 19H16v2h5v-5h-2v1.6l-4.3-4.3-1.4 1.4 4.3 4.3Z"/>',
    "</svg>",
  ].join("");

  slide.appendChild(button);
  return button;
}

function getOrCreateProductImageModal() {
  var existingModal = document.getElementById("mc-product-image-modal");
  if (existingModal) return existingModal;

  var modal = document.createElement("div");
  modal.id = "mc-product-image-modal";
  modal.className = "mc-product-image-modal";
  modal.hidden = true;
  modal.setAttribute("aria-hidden", "true");
  modal.setAttribute("role", "dialog");
  modal.setAttribute("aria-modal", "true");
  modal.setAttribute("aria-labelledby", "mc-product-image-modal-title");
  modal.setAttribute("aria-describedby", "mc-product-image-modal-status");

  modal.innerHTML = [
    '<div class="mc-product-image-modal__backdrop" data-mc-product-image-modal-close></div>',
    '<div class="mc-product-image-modal__dialog" role="document" tabindex="-1">',
    '<h2 id="mc-product-image-modal-title" class="visually-hidden">Product image gallery</h2>',
    '<p id="mc-product-image-modal-status" class="visually-hidden" aria-live="polite" role="status"></p>',
    '<button type="button" class="mc-product-image-modal__close" aria-label="Close product image gallery" data-mc-product-image-modal-close><span aria-hidden="true">&times;</span></button>',
    '<button type="button" class="mc-product-image-modal__nav mc-product-image-modal__nav--prev" aria-label="View previous product image"><span aria-hidden="true">&#8249;</span></button>',
    '<figure class="mc-product-image-modal__figure">',
    '<div class="mc-product-image-modal__frame">',
    '<span class="mc-product-image-modal__loading" aria-hidden="true">Loading image</span>',
    '<img class="mc-product-image-modal__image" alt="">',
    '<p class="mc-product-image-modal__error" hidden>Image could not be loaded.</p>',
    "</div>",
    '<figcaption class="mc-product-image-modal__caption"></figcaption>',
    "</figure>",
    '<button type="button" class="mc-product-image-modal__nav mc-product-image-modal__nav--next" aria-label="View next product image"><span aria-hidden="true">&#8250;</span></button>',
    "</div>",
  ].join("");

  document.body.appendChild(modal);

  modal.addEventListener("click", function (event) {
    if (
      event.target.closest &&
      event.target.closest("[data-mc-product-image-modal-close]")
    ) {
      closeProductImageModal(modal);
    }
  });

  document.addEventListener("keydown", function (event) {
    if (!modal.classList.contains("is-open")) return;

    if (event.key === "Escape") {
      event.preventDefault();
      closeProductImageModal(modal);
    } else if (event.key === "Tab") {
      trapProductImageModalFocus(event, modal);
    } else if (event.key === "ArrowLeft") {
      event.preventDefault();
      showAdjacentProductModalImage(modal, -1);
    } else if (event.key === "ArrowRight") {
      event.preventDefault();
      showAdjacentProductModalImage(modal, 1);
    }
  });

  modal
    .querySelector(".mc-product-image-modal__nav--prev")
    .addEventListener("click", function () {
      showAdjacentProductModalImage(modal, -1);
    });

  modal
    .querySelector(".mc-product-image-modal__nav--next")
    .addEventListener("click", function () {
      showAdjacentProductModalImage(modal, 1);
    });

  return modal;
}

function openProductImageModal(slide, modal) {
  var closeButton = modal.querySelector(".mc-product-image-modal__close");
  var gallerySlides = getProductModalSlides(slide);
  var activeIndex = gallerySlides.indexOf(slide);

  if (!gallerySlides.length || activeIndex < 0) return;

  modal._mcLastFocusedElement = document.activeElement;
  modal._mcGallerySlides = gallerySlides;
  modal.hidden = false;
  showProductModalImage(modal, activeIndex);
  modal.classList.add("is-open");
  modal.setAttribute("aria-hidden", "false");
  lockProductModalScroll(modal);

  if (closeButton) closeButton.focus();
}

function closeProductImageModal(modal) {
  var image = modal.querySelector(".mc-product-image-modal__image");

  modal.classList.remove("is-open");
  modal.setAttribute("aria-hidden", "true");
  unlockProductModalScroll(modal);

  if (image) {
    image.onload = null;
    image.onerror = null;
    image.removeAttribute("src");
    image.alt = "";
  }

  if (
    modal._mcLastFocusedElement &&
    typeof modal._mcLastFocusedElement.focus === "function"
  ) {
    modal._mcLastFocusedElement.focus();
  }

  window.setTimeout(function () {
    if (!modal.classList.contains("is-open")) {
      modal.hidden = true;
    }
  }, 220);
}

function getProductModalSlides(slide) {
  var galleryRoot = slide.closest(".mc-main-product__image-slider") || document;
  return Array.prototype.slice
    .call(galleryRoot.querySelectorAll(".swiper-slide.has-zoom"))
    .filter(function (gallerySlide) {
      return getProductModalImageSrc(gallerySlide);
    });
}

function showAdjacentProductModalImage(modal, direction) {
  var gallerySlides = modal._mcGallerySlides || [];
  var nextIndex = (modal._mcActiveIndex || 0) + direction;

  if (nextIndex < 0 || nextIndex >= gallerySlides.length) return;

  showProductModalImage(modal, nextIndex);
}

function showProductModalImage(modal, index) {
  var gallerySlides = modal._mcGallerySlides || [];
  var slide = gallerySlides[index];
  var image = modal.querySelector(".mc-product-image-modal__image");
  var caption = modal.querySelector(".mc-product-image-modal__caption");
  var status = modal.querySelector("#mc-product-image-modal-status");
  var error = modal.querySelector(".mc-product-image-modal__error");
  var prevButton = modal.querySelector(".mc-product-image-modal__nav--prev");
  var nextButton = modal.querySelector(".mc-product-image-modal__nav--next");
  var imageSrc = slide ? getProductModalImageSrc(slide) : "";
  var imageAlt = slide ? getProductModalImageAlt(slide) : "";
  var imageLabel = imageAlt || "Product image";
  var requestId = Date.now() + "-" + index;

  if (!image || !slide || !imageSrc) return;

  modal._mcActiveIndex = index;
  modal._mcActiveSlide = slide;
  modal._mcImageRequestId = requestId;
  modal.classList.remove("is-loaded", "is-error");
  modal.classList.add("is-loading");

  if (caption) {
    caption.textContent = imageAlt;
    caption.hidden = !imageAlt;
  }

  if (status) {
    status.textContent =
      "Loading image " + (index + 1) + " of " + gallerySlides.length + ".";
  }

  if (error) error.hidden = true;

  if (prevButton) {
    prevButton.hidden = gallerySlides.length < 2;
    prevButton.disabled = index === 0;
  }

  if (nextButton) {
    nextButton.hidden = gallerySlides.length < 2;
    nextButton.disabled = index === gallerySlides.length - 1;
  }

  if (
    document.activeElement &&
    document.activeElement.disabled &&
    modal.contains(document.activeElement)
  ) {
    var closeButton = modal.querySelector(".mc-product-image-modal__close");
    if (closeButton) closeButton.focus();
  }

  image.onload = function () {
    if (modal._mcImageRequestId !== requestId) return;
    modal.classList.remove("is-loading", "is-error");
    modal.classList.add("is-loaded");
    if (status) {
      status.textContent =
        "Showing image " +
        (index + 1) +
        " of " +
        gallerySlides.length +
        ". " +
        imageLabel;
    }
  };

  image.onerror = function () {
    if (modal._mcImageRequestId !== requestId) return;
    modal.classList.remove("is-loading", "is-loaded");
    modal.classList.add("is-error");
    if (error) error.hidden = false;
    if (status) status.textContent = "Product image could not be loaded.";
  };

  image.alt = imageAlt;
  image.src = imageSrc;

  if (image.complete && image.naturalWidth) {
    image.onload();
  }
}

function trapProductImageModalFocus(event, modal) {
  var focusableElements = getProductModalFocusableElements(modal);
  var firstFocusableElement = focusableElements[0];
  var lastFocusableElement = focusableElements[focusableElements.length - 1];

  if (!focusableElements.length) {
    event.preventDefault();
    modal.querySelector(".mc-product-image-modal__dialog").focus();
    return;
  }

  if (!modal.contains(document.activeElement)) {
    event.preventDefault();
    firstFocusableElement.focus();
    return;
  }

  if (event.shiftKey && document.activeElement === firstFocusableElement) {
    event.preventDefault();
    lastFocusableElement.focus();
  } else if (!event.shiftKey && document.activeElement === lastFocusableElement) {
    event.preventDefault();
    firstFocusableElement.focus();
  }
}

function getProductModalFocusableElements(modal) {
  return Array.prototype.slice
    .call(
      modal.querySelectorAll(
        'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])',
      ),
    )
    .filter(function (element) {
      return !element.hidden && element.offsetParent !== null;
    });
}

function lockProductModalScroll(modal) {
  if (modal._mcScrollLocked) return;

  modal._mcPreviousBodyOverflow = document.body.style.overflow;
  document.body.style.overflow = "hidden";
  document.body.classList.add("mc-product-image-modal-open");
  modal._mcScrollLocked = true;
}

function unlockProductModalScroll(modal) {
  if (!modal._mcScrollLocked) return;

  document.body.style.overflow = modal._mcPreviousBodyOverflow || "";
  document.body.classList.remove("mc-product-image-modal-open");
  modal._mcScrollLocked = false;
}

function getProductModalImageSrc(slide) {
  return (
    slide.getAttribute("data-zoom-src") ||
    slide.getAttribute("data-img-src") ||
    getMcMainProductSlideImageUrl(slide)
  );
}

function getProductModalImageAlt(slide) {
  var img = slide.querySelector("img");
  return img ? img.getAttribute("alt") || "" : "";
}
